import React, { createContext, useContext, useRef, ReactNode } from 'react'

interface ScrollContextType {
  scrollToTop: () => void
  layoutContentRef: React.RefObject<HTMLDivElement | null>
}

const ScrollContext = createContext<ScrollContextType | undefined>(undefined)

interface ScrollProviderProps {
  children: ReactNode
}

export function ScrollProvider({ children }: ScrollProviderProps) {
  const layoutContentRef = useRef<HTMLDivElement>(null)

  const scrollToTop = () => {
    if (layoutContentRef.current) {
      layoutContentRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
  }

  return (
    <ScrollContext.Provider value={{ scrollToTop, layoutContentRef }}>
      {children}
    </ScrollContext.Provider>
  )
}

export const useScroll = (): ScrollContextType => {
  const context = useContext(ScrollContext)
  if (!context) {
    throw new Error('useScroll must be used within a ScrollProvider')
  }
  return context
}
